import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSubscription } from '../SubscriptionContext';

const PlanGuard = ({ allowedPlans }) => {
  const { plan, loading } = useSubscription();

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>プラン情報を確認中...</div>;
  }

  // Trial plan allows everything
  if (plan === 'trial') {
    return <Outlet />;
  }

  if (!plan || !allowedPlans.includes(plan)) {
    return <Navigate to="/permission-denied" replace />;
  }

  return <Outlet />;
};

export default PlanGuard;
